function getImpressionRequestOneData(impressionRequest) {
  const request = {
    countryCode: impressionRequest.country_code,
    version: impressionRequest.version,
    languageCode: impressionRequest.language_code,
    userLocalTimestamp: new Date().toISOString().replace('T', ' '),
    userAction: impressionRequest.user_action,
    category: impressionRequest.category,
    impressions: impressionRequest.impressions,
  };
  return request;
}


export default getImpressionRequestOneData;
